// extracted by mini-css-extract-plugin
module.exports = {"etTransactions":"App_etTransactions__3XDRo"};